import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import { Box, Typography } from '@mui/material'

import { PageDisplayer } from '../../../../ui'
import { IPForm } from '../form'
import { useIPDetail } from '../../contexts'

export const IPDetail = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { ipId } = useParams()
  const { formatMessage } = useIntl()
  const { loading, error, getIP } = useIPDetail()

  useEffect(() => {
    getIP(ipId)
  }, [ipId]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleGoBack = () => {
    const prevSearch = location.state?.prevSearch || ''
    navigate('/ip' + prevSearch)
  }

  return (
    <PageDisplayer
      maxWidth="md"
      loading={loading}
      handleGoBack={handleGoBack}
      textGoBack={formatMessage({ id: 'pages.ipDetail.goBack' })}
    >
      {error ? (
        formatMessage({ id: 'pages.ipDetail.error' })
      ) : (
        <>
          <Box mb={2}>
            <Typography variant="h4" color="textSecondary">
              {formatMessage({ id: 'pages.ipDetail.title' })}
            </Typography>
          </Box>
          <IPForm />
        </>
      )}
    </PageDisplayer>
  )
}
